import { requestHandler } from '../../../api';

export const getAvailableBusinessForFund = async (dispatch: any) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/multiverse/fund/shared`,
    dispatch,
  });
  if (response) return response.data;
};

export const getSharedBusinessDataHubLightReport = async (
  dispatch: any,
  businessIdentifier: string,
  companyId: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/multiverse/fund/${companyId}/${businessIdentifier}/datahubLightReport/${businessIdentifier}`,
    dispatch,
  });
  if (response) return response.data;
};

export const createSharedCreditLineEvaluation = async (
  dispatch: any,
  payload: any,
  businessIdentifier: string,
  companyId: number,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/multiverse/fund/${companyId}/${businessIdentifier}/decisionEngine/creditLine`,
    data: payload,
    dispatch,
  });
  if (response) return response.data;
};
